import { api } from "./axios";

export async function getAllCoupons() {
    let res = await api.get("coupon/getAll");
    if (res) return res.data.data;
    else return false;
}

export async function deleteCoupon(id) {
    let res = await api.get("coupon/remove/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function createNewCoupons(data) {
    let res = await api.post("coupon/store", data);
    if (res) return res.data.data;
    else return false;
}

export async function updateCoupons(id, data) {
    let res = await api.post("coupon/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

export async function getCouponsDetails(id) {
    let res = await api.get("coupon/show/" + id);
    if (res) return res.data.data;
    else return false;
}

